"use client"

import ErrorComponent from "components/error-handler"

export default function GlobalError({ error }: { error: Error }) {
  return (
    <html>
      <body>
        <ErrorComponent
          error={error}
          tags={{ context: "global_error_boundary" }}
        />
      </body>
    </html>
  )
}
